import React from 'react'
import EditFontDetails from "./edit-font-details";
import EditColorDetails from "./edit-color-details";
import EditDimensionDetails from "./edit-dimension-details";
import EditStrokeDetails from "./edit-stroke-details";
import EditShadowDetails from "./edit-shadow-details";

const QuoteSettings = ({quote, handleQuoteSettingsChanges, handleQuoteDisplayTextChanges}) => {
    return (
        <>

            <div className="justify-start">
                <div className="items-center justify-center">
                    <div className="mr-2 w-full mb-1">
                        <label className="font-bold" htmlFor='displayText'>Display Text</label>
                    </div>
                    <textarea id="displayText"
                              name="displayText"
                              value={quote?.displayText}
                              onChange={handleQuoteDisplayTextChanges}
                              className="text-area-field"/>
                </div>

                <div>
                    <EditDimensionDetails settings={quote?.settings}
                                          handleDimensionDetailsChanges={handleQuoteSettingsChanges}/>
                </div>
                <div>
                    <EditFontDetails displayTextItem={quote?.settings}
                                     handleFontDetailsChanges={handleQuoteSettingsChanges}/>
                </div>
                <div>
                    <EditColorDetails displayTextItem={quote?.settings}
                                      handleColorDetailsChanges={handleQuoteSettingsChanges}/>
                </div>
                <div>
                    <EditStrokeDetails parentForm={quote?.settings}
                                       handleStrokeDetailsChanges={handleQuoteSettingsChanges}/>
                </div>
                <div>
                    <EditShadowDetails parentForm={quote?.settings}
                                       handleShadowDetailsChanges={handleQuoteSettingsChanges}/>
                </div>
            </div>

        </>
    )
}

export default QuoteSettings
